//librerías
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useNavigate } from "react-router-dom";

//context
import { AuthContext } from "../../../../context/AuthContext";

//componentes
import { Button, Container, Spinner } from "react-bootstrap";
import {
  faPen,
  faSquarePlus,
  faToggleOff,
  faToggleOn,
} from "@fortawesome/free-solid-svg-icons";

//interfaces
import { PruebaInterface } from "../../../../interfaces/PruebaInterface";

//hooks
import useFetch from "../../../../hooks/useFetch";
import { ColumnDef } from "@tanstack/react-table";
import CustomTable from "../../../Formularios/CustomTable/CustomTable";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import { toast } from "react-toastify";

//estilos
const classes = require("./PruebaTable.module.css").default;

const PruebaTable = () => {
  const authContext = useContext(AuthContext);
  //variables de estado
  const [prueba, setPrueba] = useState<PruebaInterface[]>();
  const { sendRequest, error, setError } = useFetch();
  const navigate = useNavigate();

  //Función que trata los prueba traídos de la BD.
  const transformData = useCallback((variable: any) => {
    setPrueba(variable.data);
  }, []);

  //Función que llama todos los prueba paginados
  useEffect(() => {
    sendRequest(
      {
        url: "/prueba",
      },
      transformData
    );
  }, [sendRequest, transformData]);

  //Función que desactiva a un prueba.
  const changePruebaStatus = useCallback(
    (idPrueba: number) => {
      if (
        window.confirm("¿Seguro que desea cambiar el estatus de la prueba?")
      ) {
        sendRequest(
          {
            url: `/prueba/${idPrueba}`,
            method: "DELETE",
          },
          (variable: any) => {
            setPrueba([]);
            toast.success("La prueba ha cambiado de estatus.", {
              position: "top-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            sendRequest(
              {
                url: "/prueba",
              },
              transformData
            );
          }
        );
      }
    },
    [sendRequest, transformData]
  );

  const columns = useMemo<ColumnDef<PruebaInterface>[]>(
    () => [
      {
        header: "#",
        accessorKey: "id",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
        enableColumnFilter: false,
      },
      {
        header: "Nombre",
        accessorFn: (row) => row.nombre,
        id: "nombre",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
      },
      {
        header: "Estatus",
        cell: (info) => info.getValue(),
        accessorFn: (row) => (row.estatus ? "Activo" : "Inactivo"),
      },
      {
        header: "Acciones",
        cell: (info) => (
          <div className="btn-group" role="group" aria-label="Basic example">
            <Button
              title="Editar prueba"
              style={{ backgroundColor: "#2874A6", borderColor: "white" }}
              onClick={() =>
                navigate(`/main/catalogos/prueba/edit/${info.row.original.id}`)
              }
              disabled={!authContext.tokenCan("Prueba:update")}
            >
              <FontAwesomeIcon icon={faPen as IconProp} />
            </Button>
            {/** Botón para ver eliminar*/}
            <Button
              title={
                info.row.original.estatus
                  ? "Deshabilitar prueba"
                  : "Habilitar prueba"
              }
              style={{ backgroundColor: "#0d5475", borderColor: "white" }}
              disabled={!authContext.tokenCan("Prueba:delete")}
              onClick={() => changePruebaStatus(info.row.original.id)}
            >
              <FontAwesomeIcon
                icon={(info.row.original.estatus ? faToggleOn : faToggleOff) as IconProp}
              />
            </Button>
          </div>
        ),
        footer: (props) => props.column.id,
      },
    ],
    [changePruebaStatus, navigate, authContext]
  );

  //Mientras se carga el contenido se muestra un spinner
  if (!prueba) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Lista de pruebas</h2>
      {/** Botón para agregar usuario */}
      {authContext.tokenCan("Prueba:store") && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            title="Agregar una nueva función"
            style={{
              backgroundColor: "#21618C",
              borderColor: "white",
              marginBottom: "10px",
            }}
            onClick={() => navigate(`/main/catalogos/prueba/crear`)}
          >
            <FontAwesomeIcon icon={faSquarePlus as IconProp} /> Nueva prueba
          </Button>
        </div>
      )}
      {/** Alerta de permisos */}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      <CustomTable
        {...{
          data: prueba,
          columns,
        }}
      />
    </Container>
  );
};

export default PruebaTable;
